export function getHeartVisitCount(heart) {
  const visitorCount = heart?.visitorCount;
  if (Number.isFinite(visitorCount)) return visitorCount;

  const visits = heart?.visits;
  if (Array.isArray(visits)) return visits.length;
  if (Number.isFinite(visits)) return visits;

  return null;
}
